import type { PDPContent } from "@/lib/productContent";

export function TLDRCard({ tldr }: { tldr: PDPContent["tldr"] }) {
  return (
    <section aria-labelledby="tldr-heading" className="mt-8 md:mt-10">
      <div className="relative">
        {/* soft ambient glow */}
        <div
          aria-hidden
          className="pointer-events-none absolute -inset-4 rounded-[48px] bg-brand/[0.03] blur-3xl"
        />

        <div className="relative overflow-hidden rounded-[32px] border border-border bg-card p-8 shadow-[0_20px_50px_rgba(0,0,0,0.04)] md:p-10">
          {/* top glass highlight */}
          <div
            aria-hidden
            className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand/30 to-transparent"
          />

          {/* eyebrow */}
          <div className="mb-10 flex items-center gap-2">
            <div className="h-1.5 w-1.5 rounded-full bg-brand" />
            <p
              id="tldr-heading"
              className="text-[11px] font-bold uppercase tracking-[0.15em] text-brand-deep"
            >
              At a glance
            </p>
          </div>

          {/* rows */}
          <div className="space-y-7">
            <div>
              <dt className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground">
                What it is
              </dt>
              <dd className="mt-2.5 text-[15px] font-medium leading-relaxed tracking-tight text-brand-deep">
                {tldr.what}
              </dd>
            </div>

            <div className="h-px w-full bg-gradient-to-r from-border via-border to-transparent opacity-60" />

            <div>
              <dt className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground">
                Who it&apos;s for
              </dt>
              <dd className="mt-2.5 text-[15px] font-medium leading-relaxed tracking-tight text-brand-deep">
                {tldr.who}
              </dd>
            </div>

            <div className="h-px w-full bg-gradient-to-r from-border via-border to-transparent opacity-60" />

            <div>
              <dt className="text-[11px] font-semibold uppercase tracking-widest text-brand">
                Primary benefit
              </dt>
              <dd className="mt-2.5 text-[15px] font-semibold leading-relaxed tracking-tight text-brand-deep">
                {tldr.benefit}
              </dd>
            </div>
          </div>

          {/* bottom corner glow */}
          <div
            aria-hidden
            className="pointer-events-none absolute -bottom-6 -right-6 h-24 w-24 rounded-full bg-brand/[0.02] blur-2xl"
          />
        </div>

        {/* bottom reflection */}
        <div
          aria-hidden
          className="mx-auto mt-6 h-px w-2/3 bg-gradient-to-r from-transparent via-border to-transparent"
        />
      </div>
    </section>
  );
}
